import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

// ⚠️ NOTE: 'token' param ab zaroori nahi hai — BFF pattern me auth cookie se
// automatically ho jaati hai. Signature backward-compatible rakha hai taaki
// jahan bhi is thunk ko `token` ke sath call kiya ja raha hai, wo na toote.
// Jab saare call-sites update ho jayein, `token` param hata sakte hain.
export const dynamicTokenPost = createAsyncThunk(
  "posts/fetchPosts",
  async ({ url, FormDataDynamic }) => {
    try {
      const formData = new FormData();
      Object.keys(FormDataDynamic).forEach((key) => {
        formData.append(key, FormDataDynamic[key]);
      });

      const response = await axiosInstance.post(url, formData, {
        headers: {
          Accept: "*/*",
        },
      });

      return response && response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
  }
);

const dynamicTokenPostSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dynamicTokenPost.pending, (state) => {
        state.status = "loading";
      })
      .addCase(dynamicTokenPost.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(dynamicTokenPost.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dynamicTokenPostSlice.reducer;